var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"vux-swipeout-button",class:{
    'vux-swipeout-button-primary': _vm.type === 'primary',
    'vux-swipeout-button-warn': _vm.type === 'warn',
    'vux-swipeout-button-default': _vm.type === 'default'
    },style:({
      width: (_vm.width + "px"),
      backgroundColor: _vm.backgroundColor,
      opacity: _vm.disabled ? '0.4' : '1'
    }),attrs:{"type":"button","disabled":_vm.disabled},on:{"click":_vm.onButtonClick}},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.text))]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }